import React from 'react'
import { Link } from 'react-router-dom'
import { Element } from 'react-scroll'

const FooterBanner = () => {
  return (
    <Element
      name="MaritimeFooterBanner"
      className="datatalent-section-gap bg-white"
    >
      <div className="container inner about-feature-list">
        <div className="row g-5">
          <div className="col-12 mt-0 px-0 px-md-4">
            <div className="row g-5 position-relative ba-footer">
              <div className="col-lg-7 p-0 mt-0">
                <h3 className="color-white">Ready to Transform<br></br>Public Services with AI?</h3>
                <p className="color-white">Connect with our experts to explore<br></br>how AI and Edge solutions can enhance<br></br>transparency, efficiency, and<br></br>responsiveness across your government<br></br>or policy initiatives.</p>
                <Link to="/contact-us">Contact Sales <img src={`${process.env.PUBLIC_URL}/images/business-accelerator/icons/maki_arrow.svg`} alt="right arrow" /></Link>
              </div>
              <div className="col-lg-2 d-none d-md-block"></div>
              <div className="col-lg-3 p-0 justify-content-center align-items-center d-flex">
                <Link className="edu-btn datatalent-cta" to="/contact-us">Contact Us</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Element>
  )
}

export default FooterBanner